import { createContext, useContext } from 'react';


export const SettingsContext = createContext({});

export const useSettingsContext = () => {
    const context = useContext(SettingsContext);
    if(!context) throw new Error('useSettingsContext mus be use inside SettingsProvider')
    return context;
}